import React from 'react'
import { Tag } from 'antd'
import Disclaimer from '../../components/Disclaimer'
const GeneralDetailsComponent = ({ data }) => {

    return (
        <div className="voyageData-Card">
            <div className="voyageData-Card-Elements">
                <div className="voyageData-Card-Children">
                    <div className="voyageData-Card-Children-Data">
                        <div className="voyageData-Card-Children-Data1">
                            <h1>Cargo Weight (MT)</h1>
                        </div>
                        <div className="voyageData-Card-Children-Data2">
                            <p>{data?.total_cargo_mt?.toFixed(3)}</p>
                        </div>
                    </div>
                    <div className="voyageData-Card-Children-Data">
                        <div className="voyageData-Card-Children-Data1">
                            <h1>Condition</h1>
                        </div>
                        <div className="voyageData-Card-Children-Data2">
                            <p>{data?.condition}</p>
                        </div>
                    </div>
                    <div className="voyageData-Card-Children-Data">
                        <div className="voyageData-Card-Children-Data1">
                            <h1>Distance (MT)</h1>
                        </div>
                        <div className="voyageData-Card-Children-Data2">
                            <p>{data?.distance_travelled?.toFixed(3)}</p>
                        </div>
                    </div>
                </div>

                <div className="voyageData-Card-Children">
                    <div className="voyageData-Card-Children-Data">
                        <div className="voyageData-Card-Children-Data1">
                            <h1>EEOI</h1>
                        </div>
                        <div className="voyageData-Card-Children-Data2">
                            <p>{data?.eeoi?.toFixed(3)}</p>
                        </div>
                    </div>
                    <div className="voyageData-Card-Children-Data">
                        <div className="voyageData-Card-Children-Data1">
                            <h1>EUA</h1>
                        </div>
                        <div className="voyageData-Card-Children-Data2">
                            <p>{data?.eua?.toFixed(3)}</p>
                        </div>
                    </div>
                    <div className="voyageData-Card-Children-Data">
                        <div className="voyageData-Card-Children-Data1">
                            <h1>EU Identifier</h1>
                        </div>
                        <div className="voyageData-Card-Children-Data2">
                            <p>{data?.eu_identifer}</p>
                        </div>
                    </div>
                </div>

                <div className="voyageData-Card-Children">
                    <div className="voyageData-Card-Children-Data">
                        <div className="voyageData-Card-Children-Data1">
                            <h1>Cll*</h1>
                        </div>
                        <div className="voyageData-Card-Children-Data2">

                            <Tag
                                color={
                                    data?.technical_grade === 'A'
                                        ? 'rgb(113, 189, 126)'
                                        : data?.technical_grade === 'B'
                                            ? 'rgb(214, 233, 201)'
                                            : data?.technical_grade === 'C'
                                                ? 'rgb(249, 226, 143)'
                                                : data?.technical_grade === 'D'
                                                    ? 'rgb(251, 212, 193)'
                                                    : data?.technical_grade === 'E'
                                                        ? 'rgb(255, 133, 133)'
                                                        : 'white'
                                }
                            > 
                                {data?.technical_grade === '' ? '-' : data?.technical_grade} {data?.cii?.toFixed(3)}
                            </Tag>

                            <Disclaimer />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default GeneralDetailsComponent